import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "text-center"
}
const _hoisted_3 = { class: "flex justify-end gap-6 my-2" }


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliatePayout',
  props: {
  data: Object as () => any,
  config: Object as () => { title: string; confirm: boolean; action: Function },
},
  emits: ["close"],
  setup(__props, { emit }) {

const props = __props



const onAction = () => {
  props.config?.action(props.data);
  emit("close");
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.data)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(__props.config?.title === "Approve" ? "Confirm" : "Reject") + " payout " + _toDisplayString(Number(__props.data?.total / 100).toFixed(2)) + " to user " + _toDisplayString(__props.data?.affiliate?.username) + "? ", 1))
      : (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.config?.title) + " this transaction", 1)),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: "bg-blue-500 focus:ring ring-2 ring-offset-2 text-white px-4 rounded",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (onAction()))
      }, " Yes "),
      _createElementVNode("button", {
        class: "bg-red-500 focus:ring ring-2 ring-offset-2 text-white px-4 rounded",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, " No ")
    ])
  ], 64))
}
}

})